<template>
    <div>
        <span aria-hidden="true" class="auxiliary-text mb-3">
            {{ $dayjs(date).format('YYYY/MM/DD') }}
        </span>

        <h3 class="font-Poppins font-bold text-lg sm:text-2xl pb-5">
            {{ title }}
        </h3>

        <p class="pb-2">{{ description }}</p>

        <Button
            tabindex="-1"
            aria-hidden="true"
            :label="$t('generic.read_more')"
            class="p-button-secondary p-button-text -translate-x-2"
            icon="pi pi-chevron-right"
        ></Button>
    </div>
</template>

<script>
export default {
    name: 'PressReleaseCardContents',
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped></style>
